import { APIHandler } from "../../base";

export const fetchUsersWithKBRoles = (companyId: number, query?: string) =>
    APIHandler.get(`/admin/${companyId}/userManagement/users${query || ""}`);

export const fetchInvitedUsersWithKB = (companyId: number, query?: string) =>
    APIHandler.get(`/admin/${companyId}/userManagement/invitedUsers${query || ""}`);

export const addUsersToKBs = (
    companyId: number,
    data: { emails: string[]; knowledgeBaseUids: string[]; role: string }
) => APIHandler.post(`/admin/${companyId}/userManagement/users/addToKBs`, data);

export const removeUsersFromKBs = (
    companyId: number,
    data: { userUids: string[]; knowledgeBaseUids: string[] }
) => APIHandler.post(`/admin/${companyId}/userManagement/users/removeFromKBs`, data);

export const changeKBRoles = (
    companyId: number,
    data: { userUids: string[]; knowledgeBaseUids: string[]; role: string }
) => APIHandler.patch(`/admin/${companyId}/userManagement/users/changeKBRoles`, data);

export const resendInvitations = (
    companyId: number,
    data: { inviteIds?: number[]; userUids?: string[] }
) => APIHandler.post(`/admin/${companyId}/userManagement/invitedUsers/resend`, data);

export const deleteInvitations = (companyId: number, data: { inviteIds: number[] }) =>
    APIHandler.delete(`/admin/${companyId}/userManagement/invitedUsers`, { data });

export const deleteUsers = (companyId: number, data: { userUids: string[] }) =>
    APIHandler.post(`/admin/${companyId}/userManagement/users/delete`, data);

export const changeInvitedUserRoles = (
    companyId: number,
    data: { inviteIds: number[]; role: string }
) => APIHandler.patch(`/admin/${companyId}/userManagement/invitedUsers/roles`, data);
